import { Component } from 'react';
import PropTypes from 'prop-types';

import ThemeContext from './context';
import themes from './themes';

class ThemeProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      theme: themes.ifg,
    };
  }

  componentDidMount() {
    this.applyCssVariables(this.state.theme);
  }

  applyCssVariables = (theme) => {
    const { style } = document.documentElement;
    if (theme?.scrollBar) style.setProperty('--theme-scrollbar', theme.scrollBar);
    else style.removeProperty('--theme-scrollbar');
  };

  changeTheme = (theme) => {
    this.applyCssVariables(theme);
    this.setState({ theme });
  };

  render() {
    const { theme } = this.state;
    const { children } = this.props;

    return (
      <ThemeContext.Provider value={{ theme, changeTheme: this.changeTheme }}>
        {children}
      </ThemeContext.Provider>
    );
  }
}

ThemeProvider.propTypes = {
  children: PropTypes.any,
};

export default ThemeProvider;
